module.exports = __webpack_public_path__ + "img/login_logo.82ec5c8e.png";